export const FormHelpers = () => {

  const scrollToSubmission = () => {
    const $form = $('.js-scrollToFormSubmission')
    if ( !$form.length ) return

    // run GF event after submission
    $(document).on('gform_confirmation_loaded', function() {
      scrollToConfirmation()
    })
    scrollToConfirmation()

    function scrollToConfirmation() {
      const $elToScroll = $('.gform_confirmation_message')
        if ( !$elToScroll.length ) return

        // scroll to element and add some offset due to sticky header
        $('html, body').animate({
          scrollTop: $elToScroll.offset().top - 300,
        }, 1000)
    }
  }

  scrollToSubmission()

}